module.exports = __webpack_public_path__ + "images/7fe7b0ae2c73f62fec9bad55cf396e20.png";